import { render } from "./dashWorkView.vue?vue&type=template&id=297ae7d5"
import script from "./dashWorkView.vue?vue&type=script&lang=js"
export * from "./dashWorkView.vue?vue&type=script&lang=js"

import "./dashWorkView.vue?vue&type=style&index=0&id=297ae7d5&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__